import React, { FC, useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import styles from './TabComponent.module.scss';
import { BoddOnlyTab, TabPanel } from '../TabPanel/TabPanelComponent';

interface TabbedContent {
    label: string,
    TabbedContent: React.ReactNode,
    isBoddOnly?: boolean,
    allowQa?: boolean,
}

interface TabComponentProps {
    tabs: TabbedContent[];
    onTabChange?: (newIndex: number) => void;
    initialTabIndex?: number;
    currentTabOverride?: number | undefined; // optional override to control selected tab externally
}

const TabComponent: FC<TabComponentProps> = (props) => {
    const { tabs, initialTabIndex, onTabChange, currentTabOverride } = props;
    const [tabIndex, setTabIndex] = useState(initialTabIndex ?? 0);

    const handleTabChange = (event: React.SyntheticEvent | null, newValue: number) => {
        setTabIndex(newValue);
        if (onTabChange) {
            onTabChange(newValue);
        }
    };

    useEffect(() => {
        if (Number.isInteger(currentTabOverride) && currentTabOverride !== tabIndex) {
            handleTabChange(null, currentTabOverride ?? 0);
        }
    }, [currentTabOverride]);

    return (
        <Box className={styles.TabComponent} data-testid="TabComponent">
            <Tabs value={tabIndex} onChange={handleTabChange}>
                {tabs.map((tab, index) => (
                    tab.isBoddOnly ? (
                        <BoddOnlyTab value={index} label={tab.label} allowQa={tab.allowQa} key={tab.label} />) : (
                        <Tab value={index} label={tab.label} key={tab.label} />
                    )

                ))}
            </Tabs>
            {tabs.map((tab, index) => (

                <TabPanel index={index} value={tabIndex} key={tab.label}>
                    {tab.TabbedContent}
                </TabPanel>

            ))}
        </Box>
    );
};

export default TabComponent;

TabComponent.defaultProps = {
    initialTabIndex: 0,
    onTabChange: () => null,
    currentTabOverride: undefined,
};
